import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../helpers/reselectHelpers';
import {PermissionsEnum} from '../../models/api/roleModel';
import {SettingsTeammateUrl} from '../../models/url/settingsUrlModel';
import {AppState} from '../../store/appState';
import {getHasPermission} from '../../store/data/access/accessSelectors';
import {SettingsTeammates} from './settingsTeammates';

/*
 * Props.
 */

interface SettingsTeammatesContainerProps {
  url: SettingsTeammateUrl;
}

/*
 * Selectors.
 */

function getNamespace(_state: AppState, props: SettingsTeammatesContainerProps) {
  return props.url.namespace;
}

function makeGetCanImportCustomFieldAttributesCsv() {
  return createSelector([getNamespace, getHasPermission], (namespace, hasPermission) =>
    hasPermission(namespace, PermissionsEnum.TEAMMATE_UPDATE),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SettingsTeammatesContainerProps>()(() => ({
  canImportCustomFieldAttributesCsv: makeGetCanImportCustomFieldAttributesCsv(),
}));

export const SettingsTeammatesContainer = connect(mapStateToProps)(SettingsTeammates);
